import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { IGlobalState, IGlocalActions } from "../interfaces/globalState";
import {
  cardStateInitialState,
  errorInitialState,
  RequestStatus,
  themeFormattedInitialState,
} from "../constants";

export const useStore = create<
  IGlobalState & IGlocalActions,
  [["zustand/persist", Partial<IGlobalState>]]
>(
  persist(
    (set) => ({
      errorState: errorInitialState,
      setErrorState: (errorState) => {
        set(() => ({ errorState }));
      },

      cardState: cardStateInitialState,
      setCardState: (cardState) => {
        set(() => ({ cardState }));
      },

      cardList: [],
      setCardList: (cardList) => {
        set(() => ({ cardList }));
      },

      theme: themeFormattedInitialState,
      setTheme: (theme) => {
        set(() => ({ theme }));
      },

      userProfile: {
        data: null,
        status: RequestStatus.NOT_LOADED,
      },
      setUserProfile: (userProfile) => {
        set(() => ({ userProfile }));
      },

      amountState: {
        amount: "",
        anchor: "send",
      },
      setAmountState: (amountState) => {
        set(() => ({ amountState }));
      },

      paymentState: {
        payment: null,
      },
      setPaymentState: (paymentState) => {
        set(() => ({ paymentState }));
      },

      transactions: [],
      setTransactions: (transactions) => {
        set(() => ({ transactions }));
      },

      operations: [],
      setOperations: (operations) => {
        set(() => ({ operations }));
      },
      updateOperationStatus: (operationId, status) => {
        set((state) => ({
          operations: state.operations.map((op) =>
            op.operationId === operationId ? { ...op, status } : op
          ),
        }));
      },

      quoteState: null,
      setQuoteState: (quoteState) => {
        set(() => ({ quoteState }));
      },
      
      linkId: null,
      setLinkId: (linkId) => {
        set(() => ({ linkId }));
      },
      
      exchangeRate: null,
      setExchangerate: (exchangeRate) => {
        set(() => ({ exchangeRate }));
      },
    }),
    {
      name: "globalState",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        userProfile: state.userProfile,
        quoteState: state.quoteState,
        // linkId: state.linkId,
      }),
    }
  )
);
